import './App.css';
import Calculator from './components/Calculator';

function App() {
  return (
    <div className="flex justify-center items-center h-full w-full flex-col bg-gray-500">
      <Calculator/>
    </div>
  );
}

export default App;
